// extracted by mini-css-extract-plugin
export default {"customerChatRoomSendDiv":"CustomerChatRoomSend_customerChatRoomSendDiv__rKnKD","customerChatRoomSendBtn":"CustomerChatRoomSend_customerChatRoomSendBtn__Y8aC-"};